<template>
  <div data-testid="notification-dropdown-container">
    <div class="bell" data-testid="notification-bell">
      <Bell :size="28" />

      <div v-if="unreadNotifications.length > 0" class="notification-badge" data-testid="notification-badge">
        {{ unreadNotifications.length > 9 ? '+9' : unreadNotifications.length }}
      </div>
    </div>

    <vuestic-dropdown v-model="isNotificationsShow" position="bottom" class="notification-dropdown" data-testid="notification-dropdown">
      <div class="dropdown-content" data-testid="dropdown-content">
        <div class="dropdown-header" data-testid="dropdown-header">
          <p data-testid="dropdown-title">Notificações</p>

          <span data-testid="unread-count">{{ unreadNotifications.length }} não lidas</span>
        </div>

        <div class="dropdown-body" v-if="notificacoesTodas.length" data-testid="dropdown-body">
          <NotificationItem v-for="notification in notificacoesTodas" :key="notification.id"
            :notification="notification" @notification-click="handleNotificationClick" />
        </div>

        <div class="dropdown-footer" data-testid="dropdown-footer">
          <button class="fill-button" @click="checkAll" data-testid="mark-all-read-btn">
            <FormatListChecks :size="14" />
            Marcar tudo como lida
          </button>

          <button class="micro-button" @click="toNotifications" data-testid="view-all-btn">
            <EyeOutline :size="14" />
            Ver todas
          </button>
        </div>
      </div>
    </vuestic-dropdown>
  </div>
</template>

<script>
import Button from '../core/Button'
import Bell from 'icons/Bell'
import EyeOutline from 'icons/EyeOutline'
import FormatListChecks from 'icons/FormatListChecks'
import NotificationItem from './NotificationItem'
import { mapGetters } from 'vuex'

export default {
  components: {
    Button,
    Bell,
    EyeOutline,
    FormatListChecks,
    NotificationItem,
  },
  data() {
    return {
      notifications: [],
      isNotificationsShow: false,
    }
  },
  computed: {
    ...mapGetters(['notificacoesTodas']),
    ...mapGetters(['unreadNotifications']),
  },
  async created() {
    await this.$store.dispatch('fetchFilteredNotificacoes', { http: this.$http, page: 1 })

    Echo.private(`Notificacoes.${JSON.parse(localStorage.getItem('usuario')).id_usuario}`)
      .listen('.GetNotificacao', (e) => {
        const notificacao = e.notificacao

        if (notificacao) {
          this.$store.commit('ADD_NOTIFICACAO', notificacao)
        }
      })
  },
  methods: {
    handleNotificationClick(notificationId) {
      this.isNotificationsShow = false

      if (this.$route.name === 'notifications') {
        this.$router.replace({
          name: 'notifications',
          query: { ...this.$route.query, highlightId: notificationId }
        })
      } else {
        this.$router.push({
          name: 'notifications',
          query: { highlightId: notificationId }
        })
      }
    },
    toNotifications() {
      if (this.$route.name !== 'notifications') {
        this.$router.push({ name: 'notifications' })
      }
    },
    async checkAll() {
      const unchecked = this.notificacoesTodas.filter(item => item.is_read === false)

      if (unchecked.length) {
        const ids = unchecked.map(item => item.id)

        const message = await this.$store.dispatch('readNotifications', { http: this.$http, ids })

        this.$toasted.show(message, { position: 'top-right' })

        await this.$store.dispatch('fetchFilteredNotificacoes', { http: this.$http, page: 1 })
      }
    }
  },
  beforeDestroy() {
    Echo.leave(`Notificacoes.${JSON.parse(localStorage.getItem('usuario')).id_usuario}`)
  }
}
</script>

<style lang="scss" scoped>
.bell {
  position: relative;
  display: inline-block;

  .notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: red;
    color: white;
    font-size: 12px;
    font-weight: bold;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

.notification-dropdown {
  max-height: none !important;
  overflow: hidden !important;
  cursor: default;
  width: 22rem;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  background: #FFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;

  .dropdown-content {
    width: 100%;

    .dropdown-header {
      padding: 1rem;
      background-color: transparent;
      border-bottom: 1px solid #e0e0e0;

      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin: 0;
        font-size: 0.85rem;
        font-weight: 900;
        color: #1C2D5A;
      }

      span {
        background-color: #E0E0E0;
        padding: 0.25rem 0.75rem;
        box-sizing: border-box;
        border-radius: 14px;

        font-size: 0.75rem;
        font-weight: 600;
        color: #000;
      }
    }

    .dropdown-body {
      max-height: 20rem;
      overflow: auto;
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .dropdown-footer {
      padding: 0.75rem 1.25rem;

      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;

      .fill-button,
      .micro-button {
        all: unset;
        cursor: pointer;
      }

      .fill-button {
        display: flex;
        align-items: center;
        gap: 0.25rem;

        font-size: 0.75rem;
        font-weight: 600;
        color: #1C2D5A;
      }

      .micro-button {
        padding: 0.45rem 0.5rem;
        box-sizing: border-box;
        border-radius: 6px;
        background-color: #1C2D5A;
        font-size: 0.75rem;
        font-weight: 600;
        color: #FFFFFF;

        display: flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
          background-color: #142552;
        }
      }
    }
  }
}
</style>